/* React Higher Order Component which fetches channel data where channelId = props.channelId
    Child (InnerComponent) will only render once channel data is successfully fetched.
    child will receive props: {
        channelId: PropTypes.number,
        channelStoreState: PropTypes.shape({ initialized: PropTypes.bool, channel: PropTypes.object, activitySaves: PropTypes.object, ... })
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const ReactUtil = require('../../util/ReactUtil');
const ChannelActions = require('../../actions/ChannelActions');
const ChannelStore = require('../../stores/channel_store_reflux');
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    forceRefreshOnMount: PropTypes.bool, // force refresh of channel data, even if channel store is already initialized
    hideLoadingIcon: PropTypes.bool
};

const defaultProps = {
    forceRefreshOnMount: false,
    hideLoadingIcon: false
};

export default function withChannelData(WrappedComponent) {
    class WithChannelData extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                channelStoreState: ChannelStore.getStateChannel(props.channelId),
                getActionId: null,
                fatalError: null,
            };

            this.unsubscribes = [ChannelStore.listen(this.onChannelStoreChange.bind(this))];
        }

        UNSAFE_componentWillMount() {
            if (!this.state.channelStoreState.initialized || this.props.forceRefreshOnMount) {
                const actionId = uuid.v4();
                this.setState({ getActionId: actionId }, () => {
                    ChannelActions.getAllChannels(actionId);
                });
            }
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        onChannelStoreChange(newState) {
            let additionalState = {};
            if (newState.action.id === this.state.getActionId) {
                additionalState  = { ...additionalState, getActionId: null };
                if (!!newState.action.error) {
                    additionalState = { ...additionalState, fatalError: newState.action.error };
                }
                
            }

            this.setState({
                channelStoreState: ChannelStore.getStateChannel(this.props.channelId),
                ...additionalState
            });
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} allowStackTrace={false}/>;
            }

            if (!this.state.channelStoreState.initialized) {
                if (this.props.hideLoadingIcon) {
                    return null;
                }
                else {
                    return <LoadingMainContent />;
                }
            }

            return (
                <WrappedComponent
                    {...this.props}
                    channelStoreState={this.state.channelStoreState}
                />
            );
        }
    }

    WithChannelData.propTypes = propTypes;
    WithChannelData.defaultProps = defaultProps;
    WithChannelData.displayName = `WithChannelData(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithChannelData;
}
